import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/core/services/jwt.service";
import router from '@/router.js';
import CoreSettingsJs from "@shared/src/core/services/settings.js";

/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
	init() {
		Vue.use(VueAxios, axios);
		Vue.axios.defaults.baseURL = `${process.env.VUE_APP_API_BASE_URL}`;
	},

	getFullURL(urlpath) {
		return Vue.axios.defaults.baseURL + urlpath;
	},

	getJwtToken() {
		return `Bearer ${JwtService.getToken()}`;
	},

	/**
	 * Set the default HTTP request headers
	 */
	setHeader() {
		if (JwtService.getToken()) {
			Vue.axios.defaults.headers.common[
				"Authorization"
			] = `Bearer ${JwtService.getToken()}`;
		}
	},
	unsetHeader() {
		if (JwtService.getToken()) {
			delete Vue.axios.defaults.headers.common["Authorization"];
		}
	},
	setLanguage() {
		Vue.axios.defaults.headers.common["Language"] =
			localStorage.getItem("language") || this.defaultLanguage;
	},

	query(resource, params) {
		return Vue.axios.get(resource, params).catch(error => {
			throw new Error(`[KT] ApiService ${error}`);
		});
	},

	/**
	 * Send the GET HTTP request
	 * @param resource
	 * @param slug
	 * @returns {*}
	 */
	get(resource, slug = "", without_auth) {
		if (CoreSettingsJs.emptyObjectValidation(JwtService.getToken())) {
			delete Vue.axios.defaults.headers.common["Authorization"];
		} else {
			Vue.axios.defaults.headers.common["Authorization"] = `Bearer ${JwtService.getToken()}`;
		}
		return Vue.axios.get(`${resource}/${slug}`).catch(error => {
			CoreSettingsJs.handleApiError(error);
		});
	},

	/**
	 * Set the POST HTTP request
	 * @param resource
	 * @param params
	 * @returns {*}
	 */
	post(resource, params, without_auth) {
		if (without_auth || CoreSettingsJs.emptyObjectValidation(JwtService.getToken())) {
			delete Vue.axios.defaults.headers.common["Authorization"];
		} else {
			Vue.axios.defaults.headers.common["Authorization"] = `Bearer ${JwtService.getToken()}`;
		}

		return Vue.axios.post(`${resource}`, params).catch(error => {
			CoreSettingsJs.handleApiError(error);
		});
	},

	/**
	 * Send the UPDATE HTTP request
	 * @param resource
	 * @param slug
	 * @param params
	 * @returns {IDBRequest<IDBValidKey> | Promise<void>}
	 */
	update(resource, slug, params) {
		return Vue.axios.put(`${resource}/${slug}`, params).catch(error => {
			CoreSettingsJs.handleApiError(error);
		});
	},

	/**
	 * Send the PUT HTTP request
	 * @param resource
	 * @param params
	 * @returns {IDBRequest<IDBValidKey> | Promise<void>}
	 */
	put(resource, params) {
		return Vue.axios.put(`${resource}`, params).catch(error => {
			CoreSettingsJs.handleApiError(error);
		});
	},

	/**
	 * Send the DELETE HTTP request
	 * @param resource
	 * @returns {*}
	 */
	delete(resource) {
		return Vue.axios.delete(resource).catch(error => {
			CoreSettingsJs.handleApiError(error);
		});
	},
	uploadfile(resource, params, headers, without_auth) {
		if (without_auth) {
			delete Vue.axios.defaults.headers.common["Authorization"];
		} else {
			Vue.axios.defaults.headers.common[
				"Authorization"
			] = `Bearer ${JwtService.getToken()}`;
		}

		return Vue.axios.post(`${resource}`, params, headers);
	},
	downloadfile(resource) {
		return Vue.axios({
			url: `${resource}`,
			method: "GET",
			responseType: "blob"
		}).catch(error => {
			CoreSettingsJs.handleApiError(error);

		});
	}
};

export default ApiService;
